module.exports = __webpack_public_path__ + "img/app-store.3297ce1a.png";